import { ButtonDetail } from "../Common/Button";
import TooltipWrapper from "../Common/TooltipWrapper";
import ShowDataCell from "../Common/DataCell";
import APP_ROUTES from "src/routes/routes";
import { getRandomColor } from "src/utils/common";
import DownloadIcon from "src/assets/images/download.png";
import SequenceDetailIcon from "src/assets/images/sequence-detail.png";
import ProtectedComponent from "../Permission";
import { isEmpty } from "lodash";

const getSequenceDetailUrl = (id, params) => {
  const baseUrl = `${APP_ROUTES.SEQUENCES}/${id}`;
  const queryParams = [];

  if (params?.page) {
    queryParams.push(`page=${params.page}`);
  }

  if (params?.condition) {
    queryParams.push(`condition=${params.condition}`);
  }

  if (params?.instanceId) {
    queryParams.push(`instanceId=${params.instanceId}`);
  }

  if (params?.testPackageId) {
    queryParams.push(`testPackageId=${params.testPackageId}`);
  }

  return queryParams.length > 0 ? `${baseUrl}?${queryParams.join("&")}` : baseUrl;
};

const SequenceTagButton = ({ row, t, handleAddSequenceTag }) => {
  if (!isEmpty(row?.sequence_tags)) {
    return (
      <TooltipWrapper
        id={`sequence-tag-${row?.id}`}
        tooltipText={`#${row?.sequence_tags[0]?.display_order}: ${row?.sequence_tags[0]?.name}`}
        checkOverflow
        tooltipClassName="max-width-by-px-300"
      >
        <div
          className="tag-name p-x-16 p-y-4 rounded-pill"
          style={{
            backgroundColor: row?.sequence_tags[0]?.color || getRandomColor(),
          }}
        >
          <p className="overflow-hidden text-truncate mb-0" onClick={() => handleAddSequenceTag(row)}>
            {`#${row?.sequence_tags[0]?.display_order}: ${row?.sequence_tags[0]?.name}`}
          </p>
        </div>
      </TooltipWrapper>
    );
  }
  return (
    <div className="d-flex align-items-center fit-content">
      <TooltipWrapper
        id={`sequence-tag-${row?.id}`}
        tooltipText={t("list.table.add_tag_to_sequence")}
        tooltipClassName="max-width-by-px-300"
      >
        <div className="p-t-8 button-add-sequence-tag-container">
          <button
            type="button"
            className="button-add-tag rounded-pill btn py-0 p-x-16 height-by-px-29 shadow-sm border-1 border-secondary bg-white"
            onClick={() => handleAddSequenceTag(row)}
            onFocus={(e) => {
              // immediately blurs after focus
              e.target.blur();
            }}
          >
            <i className="bi bi-plus-lg f-s-16 text-dark"></i>
          </button>
        </div>
      </TooltipWrapper>
    </div>
  );
};

export const columns = ({ t, handleSequenceDownload, handleClickRenderSequenceVisualize, handleAddSequenceTag, params }) => [
  {
    dataField: "combination_id",
    text: t("list.table.id"),
    headerClass: "width-by-px-160 text-nowrap",
    formatter: (combination_id) => <ShowDataCell data={combination_id} />,
  },
  {
    dataField: "yamcs_package",
    text: t("list.table.linked_instance"),
    headerClass: "width-by-px-160 text-nowrap",
    formatter: (yamcs_package) => <ShowDataCell data={yamcs_package.name} />,
  },
  {
    dataField: "tag_name",
    text: t("list.table.tag_name"),
    headerClass: "width-by-px-160",
    formatter: (_, row) => <SequenceTagButton row={row} t={t} handleAddSequenceTag={handleAddSequenceTag} />,
  },
  {
    dataField: "notes",
    text: t("list.table.note"),
    headerClass: "width-by-px-160",
    formatter: (note) => <ShowDataCell data={note} />,
  },
  {
    dataField: "start_time",
    text: t("list.table.start_timestamp"),
    headerClass: "width-by-px-110 text-nowrap",
    formatter: (start_time) => <span>{start_time || ""}</span>,
  },
  {
    dataField: "end_time",
    text: t("list.table.end_timestamp"),
    headerClass: "width-by-px-110 text-nowrap",
    formatter: (end_time) => <span>{end_time || ""}</span>,
  },
  {
    dataField: "",
    text: "",
    headerClass: "width-by-px-60",
    formatter: (_, row) => (
      <TooltipWrapper id={`sequence-download-${row?.id}`} tooltipText={t("list.table.sequence_download")}>
        <button
          className="btn btn-blank border-0 p-y-8 px-0"
          onClick={(e) => {
            e.stopPropagation();
            handleSequenceDownload(row);
          }}
          onFocus={(e) => {
            // immediately blurs after focus
            e.target.blur();
          }}
        >
          <img
            src={DownloadIcon}
            className="width-by-px-24 text-dark-filter prevent-img-context-menu"
            alt="Sequence Download icon"
            onContextMenu={(e) => e.preventDefault()}
          />
        </button>
      </TooltipWrapper>
    ),
  },
  // {
  //   dataField: "",
  //   text: "",
  //   headerClass: "width-by-px-60",
  //   formatter: (_, row) => (
  //     <ButtonSequenceVisualize
  //       id={`sequence-visualize-${row?.id}`}
  //       isLoading={false}
  //       handleClick={(e) => {
  //         e.stopPropagation();
  //         handleClickRenderSequenceVisualize(row);
  //       }}
  //     />
  //   ),
  // },
  {
    dataField: "",
    text: "",
    headerClass: "width-by-px-60",
    formatter: (_, row) => (
      <ProtectedComponent id={`sequence_detail_${row?.id}`}>
        <ButtonDetail
          id={row.id}
          toUrl={getSequenceDetailUrl(row?.id, params)}
          icon={
            <img
              src={SequenceDetailIcon}
              className="width-by-px-24 text-dark-filter prevent-img-context-menu"
              alt="Sequence Detail icon"
              onContextMenu={(e) => e.preventDefault()}
            />
          }
          translation="sequence"
        />
      </ProtectedComponent>
    ),
  },
];
